import { AppNS } from 'app';

export const isInspector = (user: AppNS.User): boolean => {
  return user.roles.includes('inspector');
};

export const isClient = (user: AppNS.User): boolean => {
  return user.roles.includes('client');
};

export const isAgency = (user: AppNS.User): boolean => {
  return user.roles.includes('agency');
};

export const isBackoffice = (user: AppNS.User): boolean => {
  return user.roles.includes('backoffice');
};

export const getMainRole = (user: AppNS.User): AppNS.Role => {
  return user.roles[0];
};
